import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import CommentInput from "./";
import { selectUser, selectCurrentPostId } from "../../../../../../util/selectors";
import { createComment } from "../../../../../../actions/commentActions";

class CommentInputCreate extends Component {
  constructor(props) {
    super(props);

    this.createComment = this.createComment.bind(this);
  }

  createComment() {
    return commentText => this.props.onSubmit(this.props.postId, commentText);
  }

  render() {
    return <CommentInput {...this.props} onSubmit={this.createComment()} />;
  }
}

CommentInputCreate.propTypes = {
  className: PropTypes.string.isRequired,
  getInputRef: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: selectUser(state),
    postId: selectCurrentPostId(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (postId, commentText) => dispatch(createComment(postId, commentText)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentInputCreate);



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentInput/CommentInputCreate.js